'use client';

import { createContext, PropsWithChildren, useContext, useMemo } from 'react';

type CookieContextType = {
  cartId?: string;
  multiOrigin?: boolean;
  isActiveSiteProtection?: boolean;
  restrictAge?: boolean;
};

export const CookieContext = createContext<CookieContextType | null>(null);

export const useCookies = (): CookieContextType => {
  const ctx = useContext(CookieContext);
  if (!ctx) {
    throw new Error('useCookies must be used within a CookieProvider');
  }
  return ctx;
};

export const CookieProvider = ({
  children,
  cookies,
}: PropsWithChildren<{
  cookies:
    | {
        cartId?: string;
        multiOrigin?: boolean;
        locationId?: string;
        isActiveSiteProtection?: boolean;
        restrictAge?: boolean;
      }
    | undefined;
}>) => {
  const providerValue = useMemo(
    () => ({
      cartId: cookies?.cartId,
      multiOrigin: cookies?.multiOrigin,
      isActiveSiteProtection: cookies?.isActiveSiteProtection,
      restrictAge: cookies?.restrictAge,
    }),
    [cookies]
  );

  return (
    <CookieContext.Provider value={providerValue as CookieContextType}>
      {children}
    </CookieContext.Provider>
  );
};
